import SEO from './SEO'
import megaMenuColumns from '@/constants/mega-menu'

const sectionStyles = {
  'Design & Development': { subtitle: 'Web Design' },
  'SEO & AI Search': { subtitle: 'SEO', additionalItems: ['Keyword & Content Strategy'] },
  'Paid Media & Conversion': { subtitle: 'Digital Marketing', additionalItems: ['Campaign Performance Tracking'] },
  'Retention Marketing': { subtitle: 'Direct Engagement', additionalItems: ['Automated Email Flows', 'Customer Segmentation'] },
  'Support & Optimization': { subtitle: 'Ecommerce Management' },
  Migrations: { subtitle: 'Ecommerce Migrations' },
}

export default function ServiceSection({ category, description, image, imageAlt, href, buttonText, reverse = false }) {
  const menu = megaMenuColumns.flatMap(column => column.sections).find(section => section.name === category)
  return <SEO
    id={`home-${category.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
    reverse={!reverse}
    content={{
      ...sectionStyles[category],
      title: category,
      description,
      image,
      imageAlt,
      link: href,
      buttonText,
      list: [
        ...menu.links.map(item => ({ title: item.name, href: item.href })),
        // Added checkmarks use the same destination as this section’s main text link.
        ...(sectionStyles[category].additionalItems || []).map(title => ({ title, href })),
      ],
    }}
  />
}
